// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"523":"cc772a9d","887":"518d2d11"}[chunkId] + ".chunk.js");